<script>
    import TextField from '@smui/textfield'
    import Checkbox from '@smui/checkbox';
    import { fade } from 'svelte/transition';
    import Centering from '../layouts/Centering.svelte'
    import Heading from '../components/Heading.svelte'
    import {API_URL} from '../constants/api'
    let type = "一般"
    if(/\?type=recruit/.test(window.location.href)){
        type="採用"
    }
    let value = null;
    let value2 = null;
    let value3 = null;
    let value4 = null;
    let value5 = null;
    let value6 = null;
    let checked = false;
    let isSentSuccess = false;
    let isSending =false;
    const validation = (type,v) => {
        switch(type){
            case "required":
                return v && (v.length > 0) 
            case "全角":
                return /^[^ -~｡-ﾟ\t]+$/.test(v)
            case "tel":
                return /^0\d{9,10}$/.test(v)
            case "mail":
                return /^[ -~｡-ﾟ]+@[\w_-]+\.[\w._-]+$/.test(v)
            default :
                return  true;
        }
    } 
    const send = async ()=>{
        isSending = true
        const data = JSON.stringify({
                type:type,
                company:value,
                depart:value2,
                name:value3,
                tel:value4,
                mail:value5,
                body:value6
        })
        checked = null
        const res = await fetch(`${API_URL}/form.php`,{
            method:"POST",
            body:data
        })
        isSending = false
        if(res.ok){
            isSentSuccess = true
        }else{
            isSentSuccess = {error:true}
        }
    }
</script>
<svelte:head>
	<title>お問い合わせ | 株式会社有倉商店</title>
</svelte:head>
<div transition:fade>
    <span class="margin">

    </span>
    <Centering>
        <Heading
            text={{
                main:"CONTACT",
                sub:"お問い合わせ"
            }}
        />
    </Centering>
    <div class="contact-wrapper">
        {#if isSentSuccess.error}
        <div class="flash error">
            送信に失敗しました
        </div>
        {:else if isSentSuccess}
        <div class="flash success">
            送信しました
        </div>
        {/if}
        <form>
            
            <div class="btn">
                <input id="general" bind:group={type} type="radio" name="type" value="一般"/>
                <label for="general">資料請求や事業内容に関するお問い合わせ</label>
                <input id="recruit" bind:group={type} type="radio" name="type" value="採用"/>
                <label for="recruit">採用に関するお問い合わせ</label>
            </div>
            <div class="row">
                <p>会社名</p>
                <div class="input-wrapper">
                    <TextField 
                    type="text"
                    bind:value
                    name="company"
                    label="会社名"
                    style="width:100%"
                    >
                    </TextField>
                </div>
            </div>
            <div class="row">
                <p>部署名</p>
                <div class="input-wrapper">
                    <TextField 
                    type="text"
                    bind:value={value2}
                    name="depart"
                    label="部署名"
                    style="width:100%"
                    >
                    </TextField>
                </div>
            </div>
            <div class="row">
                <p>お名前</p><span class="required">必須</span>
                <span class="error">
                    {#if value3 === ""}
                    入力必須項目です
                    {/if}
                </span>
                <div class="input-wrapper">
                    <TextField 
                    type="text"
                    updateInvalid={!validation("required",value3)}
                    bind:value={value3}
                    name="name"
                    label="お名前"
                    style="width:100%"
                    on:focus={()=>{if(value3 === null)value3=""}}
                    >
                    </TextField>
                </div>
            </div>
            <div class="row">
                <p>電話番号</p><span class="required">必須</span>
                <span class="error">
                    {#if !validation("tel",value4) && (value4)}
                    形式が正しくありません
                    {:else if value4 === ""}
                    入力必須項目です
                    {/if}
                </span>
                <div class="input-wrapper">
                    <TextField 
                    type="tel"
                    updateInvalid={!validation("tel",value4)}
                    bind:value={value4}
                    name="tel"
                    label="数字でご入力ください(ハイフン無し)"
                    style="width:100%"
                    on:focus={()=>{if(value4 === null)value4=""}}
                    >
                    </TextField>
                </div>
            </div>
            <div class="row">
                <p>メールアドレス</p><span class="required">必須</span>
                <span class="error">
                    {#if !validation("mail",value5) && (value5)}
                    形式が正しくありません
                    {:else if value5 === ""}
                    入力必須項目です
                    {/if}
                </span>
                <div class="input-wrapper">
                    <TextField 
                    type="email"
                    updateInvalid={!validation("mail",value5)}
                    bind:value={value5}
                    name="tel"
                    label="半角英数字でご入力ください"
                    style="width:100%"
                    on:focus={()=>{if(value5 === null)value5=""}}
                    >
                    </TextField>
                </div>
            </div>
            <div class="row">
                <p>お問い合わせ内容</p><span class="required">必須</span>
                <span class="error">
                    {#if value6 === ""}
                    入力必須項目です
                    {/if}
                </span>
            </div>
            <TextField 
            textarea
            bind:value={value6}
            name="tel"
            label="お問い合わせ内容をご入力ください"
            style="width:100%;height:256px"
            variant="outlined"
            on:focus={()=>{if(value6 === null)value6=""}}
            >
            </TextField>
            <div class="checkarea">
                <Checkbox
                    bind:checked
                />
                <p>
                    <a href="/#/privacy" target="_blank">個人情報保護方針</a>について、同意の上送信します。
                </p>
            </div>
            <div class="btn-area">
                {#if (
                    (value3)
                )
                &&(
                    validation("tel",value4) && (value4)
                )
                &&(
                    validation("mail",value5)
                )
                &&(
                    value6
                ) && checked}
                <button disabled={isSending} on:click={send}>
                    送信する
                </button>
                {:else if !(
                (
                    (value3)
                )
                &&(
                    validation("tel",value4) && (value4)
                )
                &&(
                    validation("mail",value5)
                )
                &&(
                    value6
                ))}
                <p> 入力内容をご確認ください</p>
                {:else if !checked}
                <p> 個人情報保護方針について同意ください</p>
                {/if}
            </div>
        </form>
    
    </div>
</div>


<style>
    .margin{
        position: relative;
        display: inline-block;
        padding-bottom: 180px;
    }
    .btn{
        display: flex;
        justify-content: center;
    }
    .btn input{
        display: none;

    }
    .contact-wrapper{
        width: 1124px;
        display: flex;
        margin: auto;
        margin-top: 60px;
    }
    form{
        width:100%;
    }
    .btn input:checked+label{
        color:white;
        background:  #FF9B11;
    }
    .btn label{
        width: 562px;
        height: 60px;
        background:transparent;
        font-family: "Noto Sans JP";
        
        font-size: 16px;
        line-height: 60px;
        text-align: center;
        color: #FF9B11;
        border: 1px solid #FF9B11;
    }
    .required{
        display: inline-block;
        width: 60px;
        height: 30px;
        background: #ff9b11;
        border-radius:15px;
        font-family: "Noto Sans JP",sans-serif;
        
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        box-sizing: border-box;
    }
    .row{
        display: flex;
        align-items: center;
        width: 1124px;
        margin-top: 58px;
    }
    .row p{
        font-family: "Noto Sans JP",sans-serif;
        
        font-size: 24px;
        line-height: 41px;
        text-align: left;
        color: #000;
        margin-right: 24px;
    }
    .input-wrapper{
        width:677px;
        margin-left: auto;
    }
    .error{
        font-family: "Noto Sans JP",sans-serif;
        
        font-size: 12px;
        line-height: 41px;
        text-align: left;
        color: red;
        margin-left: 12px;
    }
    .checkarea{
        display: flex;
        width:440px;
        align-items: center;
        margin: auto;
        margin-top: 100px;
    }
    .checkarea p{
        font-family: "Noto Sans JP",sans-serif;
        
        font-size: 16px;
        text-align: left;
        color: #000;
        margin-left: 25px;

    }
    .checkarea a{
        color: #000;
        border-bottom: 1px solid #000;
        text-decoration: none;
    }
    .btn-area button{
        width: 375px;
        height: 52px;
        background: transparent;
        font-family: "Noto Sans JP",sans-serif;
        
        font-size: 20px;
        padding: 0;
        border: none;
        text-align: center;
        color: #fff;
        background-color: #FF9B11;
        border:2px solid  #FF9B11;
        transition:opacity .5s;
    }
    button:hover{
        opacity: 0.5;
        transition:opacity .5s;
    }
    .btn-area{
        margin-top: 40px;
        width: 375px;
        height:240px;
        display: flex;
        align-items: center;
        margin: auto;
    }
    .btn-area p{
        border:2px solid #FF9B11;
        width: 375px;
        height: 52px;
        background: transparent;
        font-family: "Noto Sans JP",sans-serif;
        
        font-size: 20px;
        padding: 0;
        margin:0;
        line-height: 52px;
        border: none;
        text-align: center;
        color: #FF9B11;
        border:2px solid  #FF9B11;
    }
    .flash{
        border-radius: 10px;
        background: #fff;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        display: flex;
        width:360px;
        height:60px;
        box-sizing: border-box;
        justify-content: center;
        position: fixed;
        z-index: 100;
        animation-name:delete;
        animation-delay:5s;
        animation-duration:1s;
        animation-fill-mode:forwards;
        pointer-events: none;
    }
    @keyframes delete{
        from{
            opacity: 1;
        }
        to{
            opacity: 0;
        }
    }
    .flash.success{
        color:#5cb85c;
        text-align: center;
        line-height: 60px;   
        font-family: "Noto Sans JP",sans-serif;
    }
    .flash.error{
        text-align: center;
        line-height: 60px;
        font-size: 16px;
    }
    @media screen and (max-width:640px){
        .btn-layout{
            width: 100%;
            margin: 0 auto;
            margin-top: 35px;
            margin-bottom: 125px;
        }
        .btn{
            flex-direction:column   
        }
        .btn label{
            width: 100%;
        }
        .contact-wrapper{
            width:100%
        }
        .row {
            width: 95%;
            margin-left: 2.5%;
            flex-wrap: wrap;
        }
        .row p{
            font-size: 16px ;
        }
        .checkarea{
            width: 90%;
        }
        .checkarea p{
            font-size: 12px;
            margin-left: 12px;
        }
        .btn-area p,.btn-area button{
            margin:0 auto ;
            width: 90%;
            font-size: 12px;
        }
        .btn-area{
            width: 100%;
        }
    }
</style>
